export default {
      id: "chevron-right-usage",
      viewBox: "0 0 15 26",
      url: "/" + "sprite.svg#chevron-right",
      toString: function () {
        return this.url;
      }
    }